export enum ModuleType {
  ONECLICK = "ONECLICK",
  OUTLIERSHIELD = "OUTLIERSHIELD",
  VALUATIONSPACKAGE = "VALUATIONSPACKAGE",
}
